import React, {Component} from 'react';
import { RichText } from 'prismic-reactjs';
import './About.css';

class About extends Component{
  render(){
    let {doc} = this.props;
    return(
      <div className="About">
        <p className="About-text">
          {RichText.render(doc.data.text)}
        </p>
      </div>
    )
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js